import { all } from 'redux-saga/effects';

import { watchApp } from 'redux/sagas/app.sagas';
import { watchBlogs } from 'redux/sagas/blogs.sagas';
import { watchServices } from 'redux/sagas/services.sagas';

export default function* rootSaga(): Generator {
  yield all([watchApp(), watchBlogs(), watchServices()]);
}
